import { useEffect, useState } from "react";
import axios from "axios";

export default function Finansijesajtovi() {
  const token = localStorage.getItem("token");
  //PRODUZI ROK UPLATE NAKON PLACENOG RACUNA

  const produziHosting = async (id, meseci = 1) => {
    try {
      await axios.put(
        `/api/finansije/produzi-hosting/${id}`,
        { meseci },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      loadWebsites();
    } catch (err) {
      console.error(err);
    }
  };

  const produziOdrzavanje = async (id) => {
    try {
      await axios.put(
        `/api/finansije/produzi-odrzavanje/${id}`,
        { meseci: 1 },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      loadWebsites();
    } catch (err) {
      console.error(err);
    }
  };

 const produziDomen = async (id, meseci = 1) => {
  try {
    await axios.put(
      `/api/finansije/produzi-domen/${id}`,
      { meseci },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    loadWebsites();
  } catch (err) {
    console.error(err);
  }
};



  const [websites, setWebsites] = useState([]);
  //const [msg, setMsg] = useState("");


  //search 
  const [search, setSearch] = useState("");


  const loadWebsites = () => {
    axios
      .get(`/api/finansijesajtovi` ,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }) 
      .then(res => setWebsites(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    loadWebsites();
  }, []);


  // Filtrirana lista po search inputu
  const filteredWebsites = websites.filter(w =>
    w.naziv.toLowerCase().includes(search.toLowerCase()) ||
    String(w.sajtID).includes(search) ||
    String(w.ref_num).includes(search) ||
    w.httpadresa.toLowerCase().includes(search.toLowerCase()) ||
    w.ime.toLowerCase().includes(search.toLowerCase()) ||
    w.email.toLowerCase().includes(search.toLowerCase())
  );



  return (
    <div className="card bg-dark text-white p-4">
      <h4>Klijenti</h4>

      {/* LOKALNI SEARCH */}
      <input
        type="text"
        className="form-control mb-3 w-25"
        placeholder="Search by ID or name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <table className="table table-dark mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Naziv</th>
            <th>http://</th>
            <th>Ref</th>
            <th>Domen exp</th>
            <th>Produzi-Domen</th>
            <th>Hosting exp</th>
            <th>Produzi-Hosting</th>
            <th>pretplata na odrzavanje</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {filteredWebsites.map(w => (
            <tr key={w.sajtID}>
              <td>{w.sajtID}</td>
              <td>{w.naziv}</td>
              <td>{w.httpadresa}</td>
              <td>{w.ref_num}</td>
              <td>{w.domen_expire}</td>
              <td>
                <select
                  onChange={(e) =>
                    produziDomen(w.sajtID, Number(e.target.value))
                  }
                >
                  <option value={1}>1 mesec</option>
                  <option value={3}>3 meseca</option>
                  <option value={6}>6 meseci</option>
                  <option value={12}>12 meseci</option>
                </select>
              </td>
              <td>{w.hosting_expire}</td>
              <td>
                <select
                  onChange={(e) =>
                    produziHosting(w.sajtID, Number(e.target.value))
                  }
                >
                  <option value={1}>1 mesec</option>
                  <option value={3}>3 meseca</option>
                  <option value={6}>6 meseci</option>
                  <option value={12}>12 meseci</option>
                </select>
              </td>
              <td>{w.rok_pretplate}</td>
              <td>
                <button onClick={() => produziOdrzavanje(w.sajtID)}>
                  Odrzavanje plaćeno
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}